export const NAME = 'pagination';
export const DEFAULT_PROPS = {
  currentPage: 0,
  itemsPerPage: 12,
};
export const ITEMS_PER_PAGE_DROPDOWN_VALUES = [DEFAULT_PROPS.itemsPerPage, 24, 36, 48, 60, 120];
